import { render, staticRenderFns } from "./wxxiangqingSubmit.vue?vue&type=template&id=7de9bd80&scoped=true"
import script from "./wxxiangqingSubmit.vue?vue&type=script&lang=js"
export * from "./wxxiangqingSubmit.vue?vue&type=script&lang=js"
import style0 from "./wxxiangqingSubmit.vue?vue&type=style&index=0&id=7de9bd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de9bd80",
  null
  
)

export default component.exports